import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Consult from '../views/Consult.vue'
import Product from '../views/Product.vue'
import ProductDetail from '../views/ProductDetail.vue'
import Training from '../views/Training.vue'
import TrainingDataAnalysis from '../views/TrainingDetail_DataAnalysis.vue'
import TrainingDetailCDO from '../views/TrainingDetail_CDO.vue'
import TrainingDetailAiTraining from '../views/TrainingDetail_AiTraining.vue'
import Industry from '../views/Industry.vue'
import Research from '../views/Research.vue'
import Cases from '../views/Cases.vue'
import CaseDetail from '../views/CaseDetail.vue'
import About from '../views/About.vue'
import TrainingDetailDataManagement from '../views/TrainingDetail_DataManagement.vue'
import ConsultDetailDigitalTransformation from '../views/ConsultDetail_DigitalTransformation.vue'
import ConsultDetailDataGovernance from '../views/ConsultDetail_DataGovernance.vue'
import ConsultDetailAuditRisk from '../views/ConsultDetail_AuditRisk.vue'
import ConsultDetailAiConsulting from '../views/ConsultDetail_AiConsulting.vue'
import AiArticles from '../views/AiArticles.vue'
import AuditRiskArticles from '../views/AuditRiskArticles.vue'
import DataGovernanceArticles from '../views/DataGovernanceArticles.vue'
import DigitalTransformationArticles from '../views/DigitalTransformationArticles.vue'
import TrainingDetailCorporateTraining from '../views/TrainingDetail_CorporateTraining.vue'
import Appointment from '../views/Appointment.vue'
import AllCourses from '../views/AllCourses.vue'
import DigitalTransformationGuide from '../views/blog/article/DigitalTransformationGuide.vue'
import SoeDigitalTrend2026 from '../views/blog/article/SoeDigitalTrend2026.vue'
import EnergyCaseStudies from '../views/blog/article/EnergyCaseStudies.vue'
import ManufacturingChallenges from '../views/blog/article/ManufacturingChallenges.vue'
import DCMMGuide from '../views/blog/article/DCMMGuide.vue'
import MasterDataManagement from '../views/blog/article/MasterDataManagement.vue'
import MetricsSystem from '../views/blog/article/MetricsSystem.vue'
import DataQualityManagement from '../views/blog/article/DataQualityManagement.vue'
import AiAuditTrend from '../views/blog/article/AiAuditTrend.vue'
import ContinuousAudit from '../views/blog/article/ContinuousAudit.vue'
import GraphComputingAML from '../views/blog/article/GraphComputingAML.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/consulting',
    name: 'Consult',
    component: Consult
  },
  {
    path: '/consulting/digital-transformation',
    name: 'ConsultDetailDigitalTransformation',
    component: ConsultDetailDigitalTransformation
  },
  {
    path: '/consulting/digital-transformation/articles',
    name: 'DigitalTransformationArticles',
    component: DigitalTransformationArticles
  },
  {
    path: '/consulting/data-governance',
    name: 'ConsultDetailDataGovernance',
    component: ConsultDetailDataGovernance
  },
  {
    path: '/consulting/data-governance/articles',
    name: 'DataGovernanceArticles',
    component: DataGovernanceArticles
  },
  {
    path: '/consulting/audit-risk-consulting',
    name: 'ConsultDetailAuditRisk',
    component: ConsultDetailAuditRisk
  },
  {
    path: '/consulting/audit-risk-consulting/articles',
    name: 'AuditRiskArticles',
    component: AuditRiskArticles
  },
  {
    path: '/consulting/ai-consulting',
    name: 'ConsultDetailAiConsulting',
    component: ConsultDetailAiConsulting
  },
  {
    path: '/consulting/ai-consulting/articles',
    name: 'AiArticles',
    component: AiArticles
  },
  {
    path: '/consulting/:serviceType',
    name: 'ConsultingDetail',
    component: Consult
  },
  {
    path: '/product',
    name: 'Product',
    component: Product
  },
  {
    path: '/product/:productType',
    name: 'ProductDetail',
    component: ProductDetail
  },
  {
    path: '/training',
    name: 'Training',
    component: Training
  },
  {
    path: '/training/data-analysis',
    name: 'TrainingDataAnalysis',
    component: TrainingDataAnalysis
  },
  {
    path: '/training/cdo',
    name: 'TrainingDetailCDO',
    component: TrainingDetailCDO
  },
  {
    path: '/training/ai-practical',
    name: 'TrainingDetailAiTraining',
    component: TrainingDetailAiTraining
  },

  {
    path: '/training/data-management',
    name: 'TrainingDetailDataManagement',
    component: TrainingDetailDataManagement
  },
  {
    path: '/training/corporate-training',
    name: 'TrainingDetailCorporateTraining',
    component: TrainingDetailCorporateTraining
  },


  {
    path: '/training/all-courses',
    name: 'AllCourses',
    component: AllCourses
  },
  {
    path: '/training/:trainingType',
    name: 'TrainingDetail',
    component: Training
  },
  {
    path: '/industry',
    name: 'Industry',
    component: Industry
  },
  {
    path: '/industry/:industryType',
    name: 'IndustryDetail',
    component: Industry
  },
  {
    path: '/research',
    name: 'Research',
    component: Research
  },
  {
    path: '/research/:researchType',
    name: 'ResearchDetail',
    component: Research
  },
  {
    path: '/case',
    name: 'Cases',
    component: Cases
  },
  {
    path: '/case/:caseType',
    name: 'CaseDetail',
    component: CaseDetail
  },
  {
    path: '/about',
    name: 'About',
    component: About
  }
  ,
  {
    path: '/appointment',
    name: 'Appointment',
    component: Appointment
  },
  {
    path: '/blog/article/digital-transformation-guide',
    name: 'DigitalTransformationGuide',
    component: DigitalTransformationGuide
  },
  {
    path: '/blog/article/soe-digital-trend-2026',
    name: 'SoeDigitalTrend2026',
    component: SoeDigitalTrend2026
  },
  {
    path: '/blog/article/energy-case-studies',
    name: 'EnergyCaseStudies',
    component: EnergyCaseStudies
  },
  {
    path: '/blog/article/manufacturing-challenges',
    name: 'ManufacturingChallenges',
    component: ManufacturingChallenges
  },
  {
    path: '/blog/article/dcmm-guide',
    name: 'DCMMGuide',
    component: DCMMGuide
  },
  {
    path: '/blog/article/master-data-management',
    name: 'MasterDataManagement',
    component: MasterDataManagement
  },
  {
    path: '/blog/article/metrics-system',
    name: 'MetricsSystem',
    component: MetricsSystem
  },
  {
    path: '/blog/article/data-quality-management',
    name: 'DataQualityManagement',
    component: DataQualityManagement
  },
  {
    path: '/blog/article/ai-audit-trend',
    name: 'AiAuditTrend',
    component: AiAuditTrend
  },
  {
    path: '/blog/article/continuous-audit',
    name: 'ContinuousAudit',
    component: ContinuousAudit
  },
  {
    path: '/blog/article/graph-computing-aml',
    name: 'GraphComputingAML',
    component: GraphComputingAML
  }
]

const SITE_ORIGIN = (process.env.VUE_APP_SITE_ORIGIN || 'https://www.gushandata.com').replace(/\/$/, '')

const defaultSeo = {
  title: '北京古杉数据-央国企审计-风险管理-合规-数字化治理一体化平台服务',
  description: '古杉数据专注企业数字化能力建设与AI应用，提供咨询规划、数据治理、审计风控产品、大模型应用及AI培训。',
  keywords: '古杉数据,数字化转型,数据治理,审计风控,AI大模型'
}

const routeSeoMap = {
  Home: {
    title: '首页 - 古杉数据科技有限公司',
    description: '古杉数据提供数字化转型、数据治理、审计风控合规、AI及大模型等咨询与培训服务，专注央企国企。',
    keywords: '古杉数据,北京古杉,数字化转型,数据治理,智能审计,风控合规,AI咨询'
  },
  Consult: {
    title: '数据咨询服务 - 古杉数据',
    description: '从战略到落地的数据咨询：数字化转型、数据治理、AI及大模型、数据监理，赋能央企国企数字与AI驱动增长。',
    keywords: '数据咨询,数字化转型,数据治理,AI咨询,风控合规'
  },
  Product: {
    title: '产品中心 - 古杉数据',
    description: '古杉数据产品中心覆盖审计、风控、合规、数据治理及AI应用场景，服务央企国企与集团企业。',
    keywords: '审计平台,风险管理系统,数据治理平台,AI产品'
  },
  Training: {
    title: '培训中心 - 古杉数据',
    description: '提供数据分析、CDO、AI实战与企业内训课程，帮助组织建设数字化与AI能力。',
    keywords: '数据分析培训,CDO培训,AI培训,企业内训'
  },
  Industry: {
    title: '行业解决方案 - 古杉数据',
    description: '面向能源电力、制造、水利等重点行业提供数字化治理、审计风控与AI解决方案。',
    keywords: '行业数字化解决方案,能源电力,制造业,审计风控'
  },
  Research: {
    title: '研究洞察 - 古杉数据',
    description: '分享数据治理、审计风控、AI大模型等领域的前沿观点与行业实践。',
    keywords: '研究洞察,数据治理,审计数字化,AI实践'
  },
  Cases: {
    title: '客户案例 - 古杉数据',
    description: '覆盖央企国企和集团企业的数字化转型、审计风控、数据治理与AI落地案例。',
    keywords: '客户案例,数字化转型案例,审计案例,数据治理案例'
  },
  About: {
    title: '关于我们 - 古杉数据',
    description: '北京古杉数据科技有限公司，专注数字化转型、数据治理、审计风控合规和AI大模型服务。',
    keywords: '古杉数据,关于我们,数字化转型,数据治理,审计风控,AI咨询'
  },
  Appointment: {
    title: '预约专家咨询 - 古杉数据',
    description: '填写信息预约一对一咨询，获取数字化转型、数据治理、审计风控、AI大模型等专业服务。',
    keywords: '预约咨询,专家咨询,数字化咨询,数据治理咨询'
  }
}

function setMetaTag(name, content) {
  if (!content) return
  let el = document.head.querySelector(`meta[name="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return { el: to.hash, behavior: 'smooth', top: 80 }
    } else {
      return { top: 0, left: 0 }
    }
  }
})

router.afterEach((to) => {
  const routeSeo = routeSeoMap[to.name] || defaultSeo
  document.title = routeSeo.title
  setMetaTag('description', routeSeo.description)
  setMetaTag('keywords', routeSeo.keywords)
  setCanonical(`${SITE_ORIGIN}${to.path || '/'}`)
})

export default router
